import React, { useContext, useState, useEffect } from 'react';
import { makeStyles } from '@fluentui/react-components';
import { GameSettingsContext } from './BridgeEngineSettings';
import { PlayStateContext, TurnMode } from './BridgeEnginePlay';
import './TurnControls.css';

const TurnControls: React.FC = () => {
    const gameSettingsContext = useContext(GameSettingsContext);
    const { gameSettings } = gameSettingsContext;

    const playStateContext = useContext(PlayStateContext)!;
    const { turnState: turn } = playStateContext;

    const handleTurnSelect = (event: React.MouseEvent<HTMLButtonElement>) => {
        const turnButtonNumber = parseInt(event.currentTarget.textContent || '0', 10);
        if (turnButtonNumber > turn.guessCount) {
            return;
        }            
        if (turnButtonNumber === turn.guessCount) {
            // this is the active turn.
            playStateContext.doneReviewing();
            return;
        }

        playStateContext.turnReview(turnButtonNumber);
    }

    const handleAnswerSelect = (event: React.MouseEvent<HTMLButtonElement>) => {
        playStateContext.showAnswer();
    }

    const buttons = Array.from({ length: 20 }, (_, i) => i + 1);
    return (
        <div className='turn-controls'>
            <span className="turn-label">Turn: </span>
            {buttons.slice(0, gameSettings.maxTurns).map((turnButton) => {
                let buttonClass = "turn-current";
                if (turnButton < turn.guessCount) {
                    buttonClass = "turn-past";
                } else if (turnButton > turn.guessCount) {
                    buttonClass = "turn-future";
                }
                return (
                    <button
                        key={turnButton}
                        className={buttonClass}
                        onMouseDown={handleTurnSelect}
                    >
                        {turnButton.toString()}
                    </button>
                );
            })}
            {playStateContext.turnState.playMode === TurnMode.Finished && (
                <button
                    key={'Answer'}
                    className='turn-answer'
                    onMouseDown={handleAnswerSelect}
                >
                    Answer
                </button>
            )}
        </div>
    );
};

export default TurnControls;